"use strict";
export const SUBGRAPH_MAX_LAG_SECONDS = 300;
export function subgraphLagSeconds(blockTimestamp) {
  if (typeof blockTimestamp !== "number" || !Number.isFinite(blockTimestamp) || blockTimestamp <= 0) {
    return void 0;
  }
  return Math.max(0, Date.now() / 1e3 - blockTimestamp);
}
export function isSubgraphStale(blockTimestamp, maxLagSeconds = SUBGRAPH_MAX_LAG_SECONDS) {
  const lag = subgraphLagSeconds(blockTimestamp);
  return lag !== void 0 && lag > maxLagSeconds;
}
